const durationRE = /(-?(?:\d+\.?\d*|\d*\.?\d+)(?:e[-+]?\d+)?)\s*([\p{L}]*)/giu;
function _p(str: string, format = 'ms'): number {
  let result: number = null!;
  // ignore commas/placeholders
  str = `${str}`.replace(/(\d)[,_](\d)/g, '$1$2');
  const isNegative = str[0] === '-';
  str.replace(durationRE, (_, n, units) => {
    units = unitRatio(units);
    if (units) result = (result || 0) + Math.abs(Number.parseFloat(n)) * units;
    return '';
  });

  return result && (result / (unitRatio(format) || 1)) * (isNegative ? -1 : 1);
}
_p.nanosecond = _p.ns = 1 / 1e6;
_p.µs = _p.μs = _p.us = _p.microsecond = 1 / 1e3;
_p.millisecond = _p.ms = _p[''] = 1;
_p.second = _p.sec = _p.s = _p.ms * 1000;
_p.minute = _p.min = _p.m = _p.s * 60;
_p.hour = _p.hr = _p.h = _p.m * 60;
_p.day = _p.d = _p.h * 24;
_p.week = _p.wk = _p.w = _p.d * 7;
_p.month = _p.b = _p.d * (365.25 / 12);
_p.year = _p.yr = _p.y = _p.d * 365.25;

function unitRatio(str: string): number {
  // @ts-ignore
  return _p[str] || _p[str.toLowerCase().replace(/s$/, '')];
}

export type Duration = number | string;
export const parseDuration = (time: Duration) => {
  if (typeof time === 'string') return _p(time) || 0;
  return time || 0;
};
export const ms = parseDuration;
